module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(this.$route.path !== '/' && this.$route.path !== '/login' && this.$store.state && this.$store.state.user) ? _c('div', [_c('side-menu')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "router-view"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "loading-general"
    }
  }, [_c('loading', {
    ref: "l_gen_m",
    attrs: {
      "info": {}
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e1b3a70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1699
// module chunks = 6